/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CompanySpaceOrganizationUnitBulkCreateResponse,
  CompanySpaceOrganizationUnitCreateResponse,
  CompanySpaceOrganizationUnitIndexResponse,
  CompanySpaceOrganizationUnitUpdateResponse,
  OrganizationUnitBulkCreate,
  OrganizationUnitCreate,
  OrganizationUnitUpdate,
  OrganizationUnitsMembershipSummaryMembershipSummaryResponse,
  OrganizationUnitsSubtreeDeletionImpactDeletionImpactResponse,
} from '../models';
import {
    CompanySpaceOrganizationUnitBulkCreateResponseFromJSON,
    CompanySpaceOrganizationUnitBulkCreateResponseToJSON,
    CompanySpaceOrganizationUnitCreateResponseFromJSON,
    CompanySpaceOrganizationUnitCreateResponseToJSON,
    CompanySpaceOrganizationUnitIndexResponseFromJSON,
    CompanySpaceOrganizationUnitIndexResponseToJSON,
    CompanySpaceOrganizationUnitUpdateResponseFromJSON,
    CompanySpaceOrganizationUnitUpdateResponseToJSON,
    OrganizationUnitBulkCreateFromJSON,
    OrganizationUnitBulkCreateToJSON,
    OrganizationUnitCreateFromJSON,
    OrganizationUnitCreateToJSON,
    OrganizationUnitUpdateFromJSON,
    OrganizationUnitUpdateToJSON,
    OrganizationUnitsMembershipSummaryMembershipSummaryResponseFromJSON,
    OrganizationUnitsMembershipSummaryMembershipSummaryResponseToJSON,
    OrganizationUnitsSubtreeDeletionImpactDeletionImpactResponseFromJSON,
    OrganizationUnitsSubtreeDeletionImpactDeletionImpactResponseToJSON,
} from '../models';

export interface CompanySpacesOrganizationUnitsBulkCreatePostRequest {
    body?: OrganizationUnitBulkCreate;
}

export interface CompanySpacesOrganizationUnitsGetRequest {
    category?: CompanySpacesOrganizationUnitsGetCategoryEnum;
    search?: string | null;
    withoutLeader?: boolean;
    withoutMembers?: boolean;
    page?: number;
    perPage?: number;
}

export interface CompanySpacesOrganizationUnitsIdDeleteRequest {
    id: string;
}

export interface CompanySpacesOrganizationUnitsIdDeletionImpactGetRequest {
    id: string;
    targetId?: number;
}

export interface CompanySpacesOrganizationUnitsIdMembershipSummaryGetRequest {
    id: string;
}

export interface CompanySpacesOrganizationUnitsIdPutRequest {
    id: string;
    body?: OrganizationUnitUpdate;
}

export interface CompanySpacesOrganizationUnitsPostRequest {
    body?: OrganizationUnitCreate;
}

/**
 * 
 */
export class OrganizationUnitApi extends runtime.BaseAPI {

    /**
     */
    async companySpacesOrganizationUnitsBulkCreatePostRaw(requestParameters: CompanySpacesOrganizationUnitsBulkCreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompanySpaceOrganizationUnitBulkCreateResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/organization_units/bulk_create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationUnitBulkCreateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CompanySpaceOrganizationUnitBulkCreateResponseFromJSON));
    }

    /**
     */
    async companySpacesOrganizationUnitsBulkCreatePost(requestParameters: CompanySpacesOrganizationUnitsBulkCreatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompanySpaceOrganizationUnitBulkCreateResponse>> {
        const response = await this.companySpacesOrganizationUnitsBulkCreatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesOrganizationUnitsGetRaw(requestParameters: CompanySpacesOrganizationUnitsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompanySpaceOrganizationUnitIndexResponse>>> {
        const queryParameters: any = {};

        if (requestParameters.category !== undefined) {
            queryParameters['category'] = requestParameters.category;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.withoutLeader !== undefined) {
            queryParameters['without_leader'] = requestParameters.withoutLeader;
        }

        if (requestParameters.withoutMembers !== undefined) {
            queryParameters['without_members'] = requestParameters.withoutMembers;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.perPage !== undefined) {
            queryParameters['per_page'] = requestParameters.perPage;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/organization_units`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CompanySpaceOrganizationUnitIndexResponseFromJSON));
    }

    /**
     */
    async companySpacesOrganizationUnitsGet(requestParameters: CompanySpacesOrganizationUnitsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompanySpaceOrganizationUnitIndexResponse>> {
        const response = await this.companySpacesOrganizationUnitsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesOrganizationUnitsIdDeleteRaw(requestParameters: CompanySpacesOrganizationUnitsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesOrganizationUnitsIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/organization_units/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async companySpacesOrganizationUnitsIdDelete(requestParameters: CompanySpacesOrganizationUnitsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.companySpacesOrganizationUnitsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async companySpacesOrganizationUnitsIdDeletionImpactGetRaw(requestParameters: CompanySpacesOrganizationUnitsIdDeletionImpactGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationUnitsSubtreeDeletionImpactDeletionImpactResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesOrganizationUnitsIdDeletionImpactGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.targetId !== undefined) {
            queryParameters['target_id'] = requestParameters.targetId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/organization_units/{id}/deletion_impact`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationUnitsSubtreeDeletionImpactDeletionImpactResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesOrganizationUnitsIdDeletionImpactGet(requestParameters: CompanySpacesOrganizationUnitsIdDeletionImpactGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationUnitsSubtreeDeletionImpactDeletionImpactResponse> {
        const response = await this.companySpacesOrganizationUnitsIdDeletionImpactGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesOrganizationUnitsIdMembershipSummaryGetRaw(requestParameters: CompanySpacesOrganizationUnitsIdMembershipSummaryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationUnitsMembershipSummaryMembershipSummaryResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesOrganizationUnitsIdMembershipSummaryGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/organization_units/{id}/membership_summary`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationUnitsMembershipSummaryMembershipSummaryResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesOrganizationUnitsIdMembershipSummaryGet(requestParameters: CompanySpacesOrganizationUnitsIdMembershipSummaryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationUnitsMembershipSummaryMembershipSummaryResponse> {
        const response = await this.companySpacesOrganizationUnitsIdMembershipSummaryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesOrganizationUnitsIdPutRaw(requestParameters: CompanySpacesOrganizationUnitsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompanySpaceOrganizationUnitUpdateResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesOrganizationUnitsIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/organization_units/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationUnitUpdateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanySpaceOrganizationUnitUpdateResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesOrganizationUnitsIdPut(requestParameters: CompanySpacesOrganizationUnitsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompanySpaceOrganizationUnitUpdateResponse> {
        const response = await this.companySpacesOrganizationUnitsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesOrganizationUnitsPostRaw(requestParameters: CompanySpacesOrganizationUnitsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompanySpaceOrganizationUnitCreateResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/organization_units`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationUnitCreateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanySpaceOrganizationUnitCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesOrganizationUnitsPost(requestParameters: CompanySpacesOrganizationUnitsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompanySpaceOrganizationUnitCreateResponse> {
        const response = await this.companySpacesOrganizationUnitsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CompanySpacesOrganizationUnitsGetCategoryEnum = {
    Department: 'department',
    JobTitle: 'job_title'
} as const;
export type CompanySpacesOrganizationUnitsGetCategoryEnum = typeof CompanySpacesOrganizationUnitsGetCategoryEnum[keyof typeof CompanySpacesOrganizationUnitsGetCategoryEnum];
